import Dropdown from '../../../../../../Components/Form/Inputs/Dropdown';
import useLanguage from '../../../../../../Services/Language/useLanguageHook';
import { ForwardCurveParameters, monthsOfDataOptions, UpsertMarketIndicatorFactorRequest } from '../../../MarketIndicatorsManagementDefinitions';
import styles from '../../MarketIndicatorFactorPage.module.scss';

interface IMarketFactorMonthsOfDataDropdownProps {
    upsertMarketIndicatorFactorRequest: UpsertMarketIndicatorFactorRequest;
    setUpsertMarketIndicatorFactorRequest: (value: UpsertMarketIndicatorFactorRequest) => void;
}

const MarketFactorMonthsOfDataDropdown: React.FC<IMarketFactorMonthsOfDataDropdownProps> = (props: IMarketFactorMonthsOfDataDropdownProps) => {
    const [translations] = useLanguage();

    return (
        <div className={styles.indicator_add_and_edit_dropdown}>
            <Dropdown
                value={(props.upsertMarketIndicatorFactorRequest.parameters as ForwardCurveParameters).monthsOfData}
                options={monthsOfDataOptions}
                handleOptionChange={(value) => {
                    props.setUpsertMarketIndicatorFactorRequest({
                        ...props.upsertMarketIndicatorFactorRequest,
                        parameters: {
                            ...props.upsertMarketIndicatorFactorRequest.parameters,
                            monthsOfData: value,
                        },
                    });
                }}
                label={translations.marketIndicatorsManagement.fields.monthsOfData}
                track={{
                    eventCategory: 'MarketIndicatorFactor',
                    eventAction: 'MonthsOfDataChanged',
                    eventValue: (props.upsertMarketIndicatorFactorRequest.parameters as ForwardCurveParameters).monthsOfData,
                }}
            />
        </div>
    );
};

export default MarketFactorMonthsOfDataDropdown;
